export enum ToastContainerId {
    TEAM_HEADER = "TEAM_HEADER",
    MY_TEAMS_PAGE = "MY_TEAMS_PAGE",
    TEAM_PAGE = "TEAM_PAGE",
}

export enum ToastReason {
    INVITE_GAME_INITIATOR_CANDIDATE_ERROR = "INVITE_GAME_INITIATOR_CANDIDATE_ERROR",
}
